const STRINGS = {
  applyButtonLabel: "Apply",
  applyButtonAriaLabel: "apply filters",
  resetFiltersButtonLabel: "Reset Filters",
  resetFiltersButtonAriaLabel: "reset filters to default",
  cancelButtonLabel: "Cancel",
  cancelButtonAriaLabel: "cancel changes to filter",
  filtersButtonLabel: "Filters",
  filtersAppliedButtonLabel: "Filters Applied",
  resetButtonAnnouncement: "filters have been reset, reset button disabled, click apply to reset results",
  resetButtonDefaultAnnouncement: "filters have been reset, reset button disabled",
  cancelButtonAnnouncement: "changes to filter have been cancelled",
  defaultInlineFilterLegend: "Filter criteria"
};
export default STRINGS;